import SinglePageLayout from './SinglePageLayout';

export default SinglePageLayout;
